function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "100,10 4.737205583711756,175.0 195.26279441628824,175.0",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "100,120 100,10 4.737205583711756,175.0",
  stroke: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "100,120 100,10 195.26279441628824,175.0",
  stroke: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "100,120 4.737205583711756,175.0 195.26279441628824,175.0",
  stroke: "black"
});

var SvgD4 = function SvgD4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d4.83db19a4.svg";
export { ForwardRef as ReactComponent };